import { render, staticRenderFns } from "./refund-tips.vue?vue&type=template&id=3ec86ef4&scoped=true&"
import script from "./refund-tips.vue?vue&type=script&lang=js&"
export * from "./refund-tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec86ef4",
  null
  
)

export default component.exports